function z_loader()
{
	var w=$(document).width();
	$(".z-loader").each(function(){
		var url;
		if(w>750)
		{
			url=$(this).data("pc");
		}
		else{
			url=$(this).data("wap");
		}
		
		$(this).attr("src",url);
	
	});
}

z_loader();

$(window).resize(function(){

z_loader();
});